/**
 * 国际热点
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("internationalHotSpotsModule", []).
controller("internationalHotSpotsCtrl", ["$scope", "$state", "$q", "$filter", "trsHttpService", "storageListenerService", function($scope, $state, $q, $filter, trsHttpService, storageListenerService) {
    initStatus();
    initData();
    $scope.switchToGjHot = function() {
        var flag = true;
        $scope.status.threeHot.hotgj = 'hot';
        $scope.status.gjHotDate = new Date();
        $scope.status.gjHotPage = {
            CURRPAGE: 1, //起始页
            PAGESIZE: 10, //每页大小
        };
        if ($scope.status.gjHotWatch === undefined) {
            $scope.status.gjHotWatch = $scope.$watch("status.gjHotDate", function(newV, oldV) {
                $scope.status.gjHotPage.CURRPAGE = 1;
                $scope.status.gjHotPage.PAGESIZE = 10;
                $scope.gjHotLoadingPromise = getGjHot();
                flag = false;
            });
        }
        if (flag) $scope.gjHotLoadingPromise = getGjHot();
    };
    $scope.gjHotpageChanged = function() {
        $scope.gjHotLoadingPromise = getGjHot();
    };
    /**
     * [pageChanged description]  分页跳转
     *  @param {string} areaRang [description]地域范围 如：全国、新疆、国际
     *  @param {string} type [description] 类型 如：三会 或 热点新闻
     *  @param {string} model [description] 对应渲染模型
     */
    $scope.pageChanged = function(areaRang, type, model) { //分页跳转
        $scope[areaRang + type + "LoadingPromise"] = getMeetingDraftList(areaRang, type, $scope.status[areaRang + type + "Meetingflg"], model).then(function(data) {});
    };
    /**
     * [switchMeetingFlg description]  切换会议类型
     *  @param {string} areaRang [description]地域范围 如：全国、新疆、国际
     *  @param {string} type [description] 类型 如：三会 或 热点新闻
     *  @param {string} model [description] 对应渲染模型
     *  @param {string} meetingFlg [description] 会议类型
     */
    $scope.switchMeetingFlg = function(areaRang, type, meetingFlg, model) { //三会切换方法
        $scope.status[areaRang + type + "Page"] = {
            CURRPAGE: 1, //起始页
            PAGESIZE: 10, //每页大小
        };
        $scope.status[areaRang + type + "Meetingflg"] = meetingFlg;
        $scope[areaRang + type + "LoadingPromise"] = getMeetingDraftList(areaRang, type, $scope.status[areaRang + type + "Meetingflg"], model);
    };
    $scope.detonatemedia = function(detail) {
        var mediaStr = "";
        if (detail.DETONATEMEDIA === undefined || detail.DETONATEMEDIA === null || detail.DETONATEMEDIA === "") {
            mediaStr = "-";
        } else {
            var mediaArr = detail.DETONATEMEDIA.split(";")
            for (var i = 0; i < mediaArr.length && i < 3; i++) {
                mediaStr = mediaStr + " " + mediaArr[i];
            }
        }
        return mediaStr;
    };

    function getGjHot() {
        var loaddate = new Date(Date.parse($scope.status.gjHotDate));
        loaddate = $filter("date")(loaddate, "yyyy-MM-dd").toString();
        var deffer = $q.defer();
        var params = {
            typeid: "widget",
            serviceid: "hotpoint",
            modelid: "hotnewslist",
            loaddate: loaddate,
            cluster_name: "international",
            area: '999',
            field: '000',
            page_no: $scope.status.gjHotPage.CURRPAGE - 1,
            page_size: $scope.status.gjHotPage.PAGESIZE,
            loadtime: loaddate
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            $scope.data.gjHotData = data.PAGEITEMS;
            $scope.status.gjHotPage = {
                CURRPAGE: data.STARTPAGE + 1, //起始页
                PAGESIZE: data.PAGESIZE || 10, //每页大小
                PAGECOUNT: data.PAGETOTAL, //总页数
                ITEMCOUNT: data.TOTALITEMCOUNT || 0 //总条数
            };
            storageListenerService.previewPageTurningStorage(data.PAGEITEMS, "GUID", "resourceDetail"); //lingyu
            deffer.resolve(data);
        });
        return deffer.promise;
    }
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            threeHot: {
                hotqg: "hot",
                hotzj: "hot",
                hotgj: "hot"
            },
            threeMeet: {
                meetqg: "mMeet",
                meetzj: "mMeet",
                meetgj: "mMeet"
            }
        };
        $scope.data = {
            meetingTime: [{
                time: "8:50",
                label: "早"
            }, {
                time: "14:50",
                label: "午"
            }, {
                time: "19:50",
                label: "晚"
            }]
        };
    }
    /**
     * [getMeetingDraftList description]  获取会议的稿件列表
     * @param {[type]} STRVALUE [description]
     */
    function getMeetingDraftList(areaRang, type, meetingflg, model) { //传入四个参数分别为地域、类型、三会参数、数据
        var map = { //创建对象，用于实现三会的数据切换
            hotqg: {
                cluster_name: "country_1",
                area: "001"
            },
            hotgj: {
                cluster_name: "international",
                area: "999"
            },
            hotzj: {
                cluster_name: "provice_1",
                area: "001020"
            }
        };
        var deffer = $q.defer(); //通过$q创建延迟对象 deferr
        var loaddate = new Date(Date.parse($scope.status[areaRang + type + "Date"])); //通过传入的参数改变三个地方当前时间
        loaddate = $filter("date")(loaddate, "yyyy-MM-dd").toString(); //改变数据类型
        var params = { //传入参数
            typeid: "widget",
            serviceid: "hotpoint",
            modelid: "getmeetingdata",
            loadtime: loaddate, //画面日期
            page_no: $scope.status[areaRang + type + "Page"].CURRPAGE - 1, //因为后台返回的页数是从0开始，所以获取的当前页-1=0
            page_size: $scope.status[areaRang + type + "Page"].PAGESIZE, //每页显示的条数
            meetingflg: meetingflg, //早会、午会、晚会参数为分别1、2、3
            cluster_name: map[areaRang].cluster_name, //map中三个聚类方式
            area: map[areaRang].area //map中地域ID
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) { //请求服务传入的参数分别为路径、初始值、请求类型
            $scope.data[model] = data.PAGEITEMS; //通过model获取数据到不同地域
            $scope.status[areaRang + type + "Page"] = { //控制分页
                CURRPAGE: data.STARTPAGE + 1, //起始页
                PAGESIZE: data.PAGESIZE || 10, //每页大小
                PAGECOUNT: data.PAGETOTAL, //总页数
                ITEMCOUNT: data.TOTALITEMCOUNT || 0 //总条数
            };
            if (data[model] === '' || data[model] === undefined || data[model] === null) {
                $scope.data.noMeetingData = meetingflg;
            }

            deffer.resolve(data); //成功时调回data
        });
        return deffer.promise; //通过deferr延迟对象，可以得到一个承诺promise，而promise会返回当前任务的完成结果
    }
    /**
     * [ switchMeetingTab description] 会议的切换标签 如：全国热点分布切换到全国三会热点
     *  @param {string} areaRang [description]地域范围 如：全国、新疆、国际
     *  @param {string} type [description] 类型 如：三会 或 热点新闻
     *  @param {string} model [description] 对应渲染模型
     *  @return {[obj]}  obj       [description] 获取宽度样式
     */
    $scope.switchMeetingTab = function(areaRang, type, model) { //两个tab切换事件，传入三个参数分别为地域、类型、数据
        //$scope.status.threeHot['hotzj'] = 'sh'
        var flag = true; //给flag赋值为true
        $scope.status[areaRang + type + "Date"] = new Date(); //赋值当前时间
        $scope.status.threeHot[areaRang] = type; //控制class的切换
        $scope.status[areaRang + type + "Meetingflg"] = 1; //初始化为早会
        $scope.status[areaRang + type + "Page"] = { //分页的对象
            CURRPAGE: 1, //起始页
            PAGESIZE: 10, //每页大小
        };
        if ($scope.status[areaRang + type + "watch"] === undefined) {
            $scope.status[areaRang + type + "watch"] = $scope.$watch("status." + areaRang + type + "Date", function(newV, oldV) {
                $scope.status[areaRang + type + "Page"].CURRPAGE = 1;
                $scope.status[areaRang + type + "Page"].PAGESIZE = 10;
                $scope[areaRang + type + "LoadingPromise"] = getMeetingDraftList(areaRang, type, $scope.status[areaRang + type + "Meetingflg"], model).then(function(data) {});
                flag = false;
            });
        }
        if (flag) $scope[areaRang + type + "LoadingPromise"] = getMeetingDraftList(areaRang, type, $scope.status[areaRang + type + "Meetingflg"], model).then(function(data) {});
    };
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {}
}]);